import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import CollectionsTable from "../../components/collections/CollectionsTable";

const Collections = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <CollectionsTable />
        </WrapperSection>
    );
};

export default Collections;
